module.exports = __webpack_public_path__ + "img/uberLogo.90a2b0eb.webp";